import React from 'react';
import { logEvent } from 'utils/amplitude';
import { NavbarItem } from 'views/shared/navbar/components/NavbarItem';

/**
 * EB Demo Link navbar item for non-EB practices to drive EB signup and engagement
 */
export const EBDemoLinkNavItem = (): JSX.Element | null => {
  const handleEBDemoLinkClick = (): void => {
    logEvent('Click EB demo link in nav bar');

    // Trigger userpilot flow
    if (window.userpilot && typeof window.userpilot.trigger === 'function') {
      window.userpilot.trigger('VV4i8LfF3j');
    }
  };

  return (
    <NavbarItem type="button" data-testid="navbar-eb-demo-link" onClick={handleEBDemoLinkClick}>
      Elation Billing
    </NavbarItem>
  );
};
